<script>
  import { Modal, Button } from "@saztrek/firefly";

  const triggerComponent = Button;
  const triggerProps = { icon: "trash" };

  export let cancelEvent;
  export let confirmEvent;

  export let branchCode;
</script>

<Modal
  {triggerComponent}
  {triggerProps}
  title="Inactivate Carry Template?"
  on:cancel={cancelEvent}
  on:confirm={confirmEvent}
  cancelButtonText="Cancel"
  confirmButtonText="Inactivate"
  buttonColor="danger">
  <p class="mb-6">Your are about to inactivate {branchCode}</p>
</Modal>
